module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMzEzMTMxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iLjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMTY3IDQuMTY3KSI+CiAgICAgICAgPGNpcmNsZSBjeD0iOC40MDMiIGN5PSIzLjQzOCIgcj0iMy40MzgiIGZpbGw9IiNFMkVBRjAiLz4KICAgICAgICA8cGF0aCBkPSJNMTYuODA2IDE1LjY2YzAtNC4yMi0zLjc2Mi03LjY0LTguNDAzLTcuNjRDMy43NjMgOC4wMiAwIDExLjQ0IDAgMTUuNjZoMTYuODA2eiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/account.svg
// module id = +oWW
// module chunks = 1